import { Component, OnInit } from '@angular/core';

interface Truck {
  name: string;
  image: string;
}

@Component({
  selector: 'app-trucking',
  templateUrl: './trucking.component.html',
  styleUrls: ['./trucking.component.scss']
})
export class TruckingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  trucks: Truck[] = [
    { name: 'Blindvan', image: 'https://storage.onindonesia.id/ondelivery.id/trucking/blindvan.png' },
    { name: 'CDD', image: 'https://storage.onindonesia.id/ondelivery.id/trucking/cdd.png' },
    { name: 'CDD Long', image: 'https://storage.onindonesia.id/ondelivery.id/trucking/cdd_long.png' },
    { name: 'CDE Long', image: 'https://storage.onindonesia.id/ondelivery.id/trucking/cde_long.png' },
    { name: 'CDE Short', image: 'https://storage.onindonesia.id/ondelivery.id/trucking/cde_short.png' },
    { name: 'Container', image: 'https://storage.onindonesia.id/ondelivery.id/trucking/container.png' },
    { name: 'FFR', image: 'https://storage.onindonesia.id/ondelivery.id/trucking/frr.png' },
    { name: 'Giga Wingbox', image: 'https://storage.onindonesia.id/ondelivery.id/trucking/giga_wingbox.png' },
    { name: 'Traga', image: 'https://storage.onindonesia.id/ondelivery.id/trucking/traga.png' },
    { name: 'Tronton', image: 'https://storage.onindonesia.id/ondelivery.id/trucking/tronton.png' },
  ];

}
